import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {routing} from './case-report.routing';
import {CaseReportComponent} from './case-report.component';
import {PanelModule} from 'primeng/primeng';
import {MstVisitService} from '../configuration/mst-visit/mst-visit.service';
import {TemrVisitHistoryService} from '../configuration/temr-visit-history/temr-visit-history.service';
import {TemrVisitChiefComplaintService} from '../configuration/temr-visit-chief-complaint/temr-visit-chief-complaint.service';
import {TemrVisitSymptomService} from '../configuration/temr-visit-symptom/temr-visit-symptom.service';
import {TemrVisitNonDrugAllergyService} from '../configuration/temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.service';
import {TemrVisitAllergyService} from '../configuration/temr-visit-allergy/temr-visit-allergy.service';
import {TemrDoctorsAdviceService} from '../configuration/temr-doctors-advice/temr-doctors-advice.service';
import {CpoeInvestigationService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-investigation/cpoe-investigation.service';
import {TemrVisitPrescriptionService} from '../configuration/temr-visit-prescription/temr-visit-prescription.service';
import {TemrVisitDiagnosisService} from '../configuration/temr-visit-diagnosis/temr-visit-diagnosis.service';
import {TemrVitalService} from '../configuration/temr-vital/temr-vital.service';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {TemrTimelineService} from '../configuration/temr-timeline/temr-timeline.service';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {CpoeDoctorAdviceService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-doctoradvice/cpoe-doctoradvice.service';
import {TemrVisitDoctorsNoteService} from '../configuration/temr-visit-doctors-note/temr-visit-doctors-note.service';
import {TemrAssociateChiefComplaintService} from '../configuration/temr-associate-chief-complaint/temr-associate-chief-complaint.service';
import {LayoutModule} from '../layout/layout.module';

@NgModule({
  imports: [
    CommonModule, routing, PanelModule, SharedTranslationModule,LayoutModule
  ],
  declarations: [CaseReportComponent],
  providers: [MstVisitService,
    TemrVisitHistoryService,
    TemrVisitChiefComplaintService,
    TemrVisitSymptomService,
    TemrVisitNonDrugAllergyService,
    TemrVisitAllergyService,
    TemrDoctorsAdviceService,
    CpoeInvestigationService,
    TemrVisitPrescriptionService,
    TemrVisitDiagnosisService,
    TemrTimelineService,
    TemrVitalService, CpoeDoctorAdviceService,
    MstUnitService, TemrVisitDoctorsNoteService, TemrAssociateChiefComplaintService]
})
export class CaseReportModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/case-report/case-report.module.ts